import { useState, useCallback } from "react";

import { useDropzone } from "react-dropzone";

import Button from "ui-components/Button";

import { UploadStatus } from "./types";

import FileStatus from "./File-Status";
import FileTag from "./File-Tag";

interface SingleFileProps {
  handleSubmit?: (f: File) => unknown;
  onFileSelect?: (f?: File) => unknown;
  uploadStatus?: UploadStatus;
}

const SingleFileUpload = ({
  handleSubmit,
  onFileSelect,
  uploadStatus,
}: SingleFileProps) => {
  const [selectedFile, setSelectedFile] = useState<File>();

  const updateFile = useCallback(
    (f?: File) => {
      setSelectedFile(f);
      if (onFileSelect) {
        onFileSelect(f);
      }
    },
    [setSelectedFile, onFileSelect]
  );

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      updateFile(acceptedFiles[0]);
    },
    [updateFile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
  });

  return (
    <div>
      {selectedFile?.name && uploadStatus && (
        <FileStatus f={selectedFile} uploadStatus={uploadStatus} />
      )}
      <div
        className="box"
        style={{ height: "200px", border: "2px dashed grey" }}
        {...getRootProps()}
      >
        <input {...getInputProps()} data-testid={"inputSelector"} />
        <div className="flex flex-col justify-center h-1/1">
          {isDragActive ? (
            <p className="text-center">Drop the files here ...</p>
          ) : (
            <p className="text-center">
              Drag 'n' drop some files here, or click to select files
            </p>
          )}
        </div>
      </div>
      {selectedFile && (
        <div className="my-1">
          <div className="flex flex-wrap">
            <FileTag file={selectedFile} onRemove={() => updateFile()} />
          </div>
        </div>
      )}
      {handleSubmit && (
        <div className="my-1">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => (selectedFile ? handleSubmit(selectedFile) : "")}
            disabled={
              !selectedFile ||
              (!uploadStatus?.error && !uploadStatus?.completed)
            }
          >
            {!uploadStatus?.error && !uploadStatus?.completed
              ? "Uploading..."
              : "Upload Selected Files"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default SingleFileUpload;
